const locale = navigator.language || navigator.userLanguage

// toLoacaleString -> Gibt Datumsformat abhängig von 'Local' aus
// Documentation: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toLocaleString

  
export const date = (value) => {
  const date = new Date(value)
  if (!value) return ''
  if (locale) {
    return date.toLocaleString([
      locale
    ], {
      month: 'short',
      day: '2-digit',
      year: 'numeric'
    })
  } else {
    return date.toLocaleString([
      'en-US'
    ], {
      month: 'short',
      day: '2-digit',
      year: 'numeric'
    })
  }
}

export const dateLong = (value) => {
  const date = new Date(value)
  if (!value) return ''
  
  if (locale) {
    return date.toLocaleString([
      locale
    ], {
      weekday: 'short',
      month: 'long',
      day: '2-digit',
      year: 'numeric'
    })
  } else {
    return date.toLocaleString([
      'en-US'
    ], {
      weekday: 'short',
      month: 'long',
      day: '2-digit',
      year: 'numeric'
    })
  }
}

export const dateShort = (value) => {
  const date = new Date(value)
  if (!value) return ''
  
  if (locale) {
    return date.toLocaleString([
      locale
    ], {
      weekday: 'short',
      month: 'long',
      day: '2-digit',
    })
  } else {
    return date.toLocaleString([
      'en-US'
    ], {
      weekday: 'short',
      month: 'long',
      day: '2-digit',
    })
  }
}

export const dateComplete = (value) => {
  const date = new Date(value)
  if (!value) return ''
  
  if (locale) {
    return date.toLocaleString([
      locale
    ], {
      month: 'short',
      day: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    })
  } else {
    return date.toLocaleString([
      'en-US'
    ], {
      month: 'short',
      day: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    })
  }


}


export const time = (value) => {
  const date = new Date(value)
  if (!value) return ''
 
  if (locale) {
    return date.toLocaleTimeString([
      locale
    ], {
      hour: '2-digit',
      minute: '2-digit'
    })
  } else {
    return date.toLocaleTimeString([
      'en-US'
    ], {
      hour: '2-digit',
      minute: '2-digit'
    })
  }
}